import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { getCookieValue } from 'app/common/utils/cookie.util';

@Component({
  selector: 'k-button',
  templateUrl: './k-button.component.html',
  styleUrls: ['./k-button.component.scss']
})

export class KButtonComponent implements OnChanges {

  @Input() id: string = 'id_button_' + Math.round(Math.random() * 10000);
  @Input() isDisabled: boolean = false;
  @Input() type: string = 'button'; //the type of button
  @Input() outline: boolean;
  @Input() height: string; //TO force height
  @Input() width: string; //TO force width
  @Input() roundedIcon: boolean = false;
  @Output() onClickAction: EventEmitter<null> = new EventEmitter<null>(); //catch to handle button click
  _style: string = "";

  ngOnChanges(changes: SimpleChanges): void {
    if (this.height) this._style = this._style + `height: ${this.height}!important; `
    if (this.width) this._style = this._style + `width: ${this.width}!important; `
  }

  clicked() {
    this.onClickAction.emit();
  }
}
